import * as React from 'react'

function SvgInteriorCheckedIcon(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <path
        d="m32.293 8.293 1.414 1.414L28 15.414l-3.707-3.707 1.414-1.414L28 12.586l4.293-4.293Z"
        fill="#2EC40B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29 3a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm-6 8a6 6 0 1 0 12 0 6 6 0 0 0-12 0Z"
        fill="#2EC40B"
      />
      <path
        d="M20 13c.075 0 .15.001.224.004.167.736.425 1.438.76 2.093a4.985 4.985 0 0 0-4.475 1.323 19.9 19.9 0 0 1 5.13-.24 9.049 9.049 0 0 0 2.552 2.43 17.896 17.896 0 0 0-11.176.922A7.002 7.002 0 0 1 20 13Z"
        fill="#000"
      />
      <path
        d="M29 20.11V20c.687 0 1.355-.076 1.998-.222L31 20c0 6.075-4.925 11-11 11S9 26.075 9 20 13.925 9 20 9l.223.002A9.025 9.025 0 0 0 20 11h-.014a8.966 8.966 0 0 0-6.085 2.381 8.976 8.976 0 0 0-2.9 6.729 9.005 9.005 0 0 0 .328 2.31 9.01 9.01 0 0 0 10.06 6.474 9.01 9.01 0 0 0 7.32-6.614 9.01 9.01 0 0 0 .29-2.17Z"
        fill="#000"
      />
      <path
        d="M14.09 23.755a6.967 6.967 0 0 1-.845-1.91L16 21.5l.063.254a3 3 0 0 0 2.183 2.183L18.5 24l.363 2.909a6.95 6.95 0 0 1-2.103-.702 7.033 7.033 0 0 1-2.67-2.453ZM23.24 26.207a6.947 6.947 0 0 1-2.103.701L21.5 24l.254-.063a3 3 0 0 0 2.183-2.183L24 21.5l2.755.345a6.964 6.964 0 0 1-.846 1.91 7.033 7.033 0 0 1-2.67 2.452Z"
        fill="#000"
      />
    </svg>
  )
}

export default SvgInteriorCheckedIcon
